(function () {
    'use strict';

    angular
        .module('app.layout')
        .controller('TopNavController', TopNavController);

    TopNavController.$inject = ['$scope', '$state', 'config', 'common', 'filters.dialog', 'userEdit.dialog', 'navRoutes'];
    /* @ngInject */
    function TopNavController($scope, $state, config, common, filterDiag, userEditDiag, navRoutes) {
        var vm = this;
        vm.title = "7 Point Solutions";
        vm.userName = "Guest";
        vm.isAdmin = "0";
        vm.isAuthenticated = false;
        vm.showFilterLink = showFilterLink;
        vm.moveDate = moveDate;
        vm.showFilters = showFilters;
        vm.isCollapsed = true;
        vm.showUser = showUser;
        vm.onDateChange = onDateChange;
        vm.datePickerOpen = false;
        vm.openDatePicker = openDatePicker;
        vm.navRoutes = [];
        vm.mobileNavRoutes = [];
        vm.isCurrent = navRoutes.isCurrent;
        vm.hasOps = common.userService.hasOps;
        vm.hideNav = hideNav;

        activate();

        function _setNavRoutes() {
            vm.navRoutes = navRoutes.getNavRoutes().filter(function (r) {
                return r.settings && !r.settings.mobileButton;
            });
            vm.mobileNavRoutes = navRoutes.getMobileNavRoutes();
        }

        function activate() {
            var d = common.getMainState("mainDate");
            if (!d) {
                common.setMainState("mainDate", new Date());
            }
            vm.onDate = common.getMainState("mainDate");
            checkUserState();
            
            common.notifier.subscribe(config.events.authenticationChange, $scope, checkUserState);
            common.notifier.subscribe(config.events.mainDateToday, $scope, goToToday);
        }

        function openDatePicker() {
            vm.datePickerOpen = !vm.datePickerOpen;
        }

        function showFilterLink() {
            if (vm.isAuthenticated) {
                if (common.userService.hasOps() == "1" && common.userService.hasDataApi() === "1" && common.userService.apiTypeId() !== common.config.apiTypes.centersXml) {
                    return true;
                }
            }
            return false;
        }

        function goToToday() {
            vm.onDate = new Date();
            common.setMainState("mainDate", new Date(vm.onDate));
            common.notifier.notify(config.events.mainDateChange, vm.onDate);
        }

        function onDateChange() {
            common.setMainState("mainDate", new Date(vm.onDate));
            common.notifier.notify(config.events.mainDateChange, vm.onDate);
        }

        function checkUserState() {
            vm.userName = common.userService.userName();
            vm.isAdmin = common.userService.userType() != "0";
            vm.isAuthenticated = common.userService.isAuthenticated();
            _setNavRoutes();
        }

        function moveDate(direction) {
            var d = common.getMainState("mainDate");
            var newDate = moment(d).add(direction, 'days');
            vm.onDate = new Date(newDate);
            common.setMainState("mainDate", new Date(newDate));
            common.notifier.notify(config.events.mainDateChange, vm.onDate);
        }

        function showFilters($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return filterDiag.display().then(function () { }, function () { });
        }

        function showUser($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return userEditDiag.display().then(function () { }, function () { });
        }

        function hideNav() {
            vm.isCollapsed = true;
        }
    }
})();
